<template>
  <div class="chart">
    <div id="echart"></div>
  </div>
</template>
<script>
import Echarts from "echarts";
export default {
  name: "foodSafetyLine",
  components: {},
  props: {
    canteenData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      echartsData: [],
      myChart: {}
    };
  },
  created() {
    this.$nextTick(() => {
      this.loadEchart();
    });
  },
  mounted() {
    let _this = this;
    // window.onresize = function () {
    //   _this.myChart.resize();
    // };
  },
  computed: {},
  watch: {
    canteenData: function(newVal) {
      this.getIngredientsPurchaseTrend();
    }
  },
  methods: {
    // 校园食品安全-食材采购趋势
    async getIngredientsPurchaseTrend() {
      if (!this.canteenData.id) {
        return;
      }
      var newParamData = {
        diningRoomId: this.canteenData.id
      };
      // console.log(newParamData)
      let res = await this.$Http.getIngredientsPurchaseTrend(
        newParamData,
        true
      );
      if (res.code == 200) {
        // console.log(res.data)
        this.echartsData = res.data;
        this.loadEchart();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    loadEchart() {
      let colors = [
        "#7d8cff",
        "#ffea3d",
        "#1aff7c",
        "#923af1",
        "#ff7d7d",
        "#107ce4",
        "#fdb006",
        "#71d6ff",
        "#f13a3a",
        "#2c9a42"
      ];
      this.myChart = Echarts.init(document.getElementById("echart"));
      let option = {
        title: {
          // text: "食材采购趋势",
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          show: true,
          itemWidth: 9,
          itemHeight: 9,
          icon: "rect",
          top: "20",
          width: 460,
          textStyle: {
            color: "#B4BBE0"
          },
          data: []
        },
        grid: {
          top: "30%",
          left: "6%",
          right: "10%",
          bottom: "10%",
          containLabel: true
        },
        toolbox: {
          // feature: {
          //   saveAsImage: {},
          // },
        },
        xAxis: {
          type: "category",
          // nameTextStyle: {
          //   color: "#B4BBE0",
          //   fontSize: 14
          // },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            // interval:0,
            // rotate:30,
            textStyle: {
              color: "#B4BBE0",
              fontSize: "14"
            }
          },
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "#4868AF",
              type: "dash",
              opacity: 0.5,
              fontSize: 14
            }
          },
          data: []
        },
        yAxis: {
          type: "value",
          nameTextStyle: {
            color: "#B4BBE0",
            fontSize: 14
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#A6E4F9",
              fontSize: "14"
            }
          },
          axisLine: {
            lineStyle: {
              color: "#4868AF",
              type: "dash",
              opacity: 0.5
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#4868AF"],
              width: 1,
              type: "dash",
              opacity: 0.1
            }
          }
        },
        series: [
          // {
          //   name: "肉类",
          //   type: "line",
          //   stack: "总量",
          //   data: [],
          //   smooth: true,
          //   symbol: "none",
          //   lineStyle: {
          //     width: 2.5,
          //     shadowColor: "rgba(255, 255, 255, 0.5)",
          //     shadowBlur: 6,
          //   },
          // }
        ],
        color: colors
      };

      let series = [];
      let seriesName = [];
      let obj = {
        name: "",
        type: "line",
        stack: "总量",
        data: [],
        smooth: true,
        symbol: "none",
        lineStyle: {
          width: 2.5,
          shadowColor: "rgba(255, 255, 255, 0.5)",
          shadowBlur: 6
        }
      };
      // console.log(this.echartsData)
      let data = this.echartsData;
      let length = this.echartsData.length;
      // console.log(length)
      for (var key in data) {
        for (var i in data[key].data) {
          // console.log(data[key].data[i])
          // console.log(i)
          let name = this.classify(data[key].data[i].type);
          let value = data[key].data[i].getTotal;
          // console.log(name)
          // console.log(value)
          if (series.length < data[key].data.length) {
            seriesName.push(name);
            // console.log(seriesName)
            let obj = {
              name: name,
              type: "line",
              stack: "总量",
              data: [],
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              lineStyle: {
                width: 2.5,
                shadowColor: "rgba(255, 255, 255, 0.5)",
                shadowBlur: 6
              }
            };
            series.push(obj);
          }
          series[i].data.push(parseInt(value));
        }
      }

      // this.modify(this.echartsData)
      // console.log(index)
      // option.series[0].data = this.echartsData.map((item) => {
      //   // console.log(item);
      //   let name = this.classify(item.data[0].type);
      //   let value = item.data[0].getTotal;
      //   // console.log(name)
      //   // console.log(value)
      //   return {
      //     name: name || '',
      //     value: value || 0,
      //   };
      // });
      option.legend.data = seriesName;
      option.series = series;
      option.xAxis.data = this.echartsData.map((item) => {
        return item.time || "";
      });
      // console.log(option.xAxis.data)
      // console.log(option.legend.data)

      this.myChart.setOption(option);
    },
    classify(type) {
      // console.log(element)
      let name = "";
      switch (type) {
        case 0:
          name = "肉类";
          break;
        case 1:
          name = "蔬菜";
          break;
        case 2:
          name = "水果";
          break;
        case 3:
          name = "饮品";
          break;
        case 4:
          name = "豆制品";
          break;
        case 5:
          name = "调味品";
          break;
        case 6:
          name = "水产品";
          break;
        case 7:
          name = "食用油";
          break;
        case 8:
          name = "粮谷类(米、面)";
          break;
        case 9:
          name = "其他";
          break;
        default:
          break;
      }
      return name;
    }
  },
  destroyed() {}
};
</script>
<style lang="scss" scoped>
.chart {
  width: 400px;
  height: 256px;
  display: flex;
  justify-content: center;
  align-items: center;
}
#echart {
  width: 400px;
  height: 256px;
  padding: 10px;
}
</style>
